import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../../components/ui/tabs';
import { Course } from '../../../types';
import { Card, CardContent } from '../../../components/ui/card';

interface CourseTabsProps {
    course: Course;
    curriculumContent: React.ReactNode;
    overviewContent?: React.ReactNode;
}

export const CourseTabs: React.FC<CourseTabsProps> = ({
    course,
    curriculumContent,
    overviewContent
}) => {
    const { t } = useTranslation();

    return (
        <Tabs defaultValue="curriculum" className="w-full">
            <TabsList className="w-full justify-start h-12 p-1 bg-gray-100/50 backdrop-blur rounded-xl mb-6">
                <TabsTrigger
                    value="curriculum"
                    className="rounded-lg data-[state=active]:bg-white data-[state=active]:shadow-sm data-[state=active]:text-indigo-600 px-6"
                >
                    {t('course.tabs.curriculum')}
                </TabsTrigger>
                <TabsTrigger
                    value="overview"
                    className="rounded-lg data-[state=active]:bg-white data-[state=active]:shadow-sm data-[state=active]:text-indigo-600 px-6"
                >
                    {t('course.tabs.overview')}
                </TabsTrigger>
                <TabsTrigger
                    value="reviews"
                    disabled
                    className="rounded-lg data-[state=active]:bg-white data-[state=active]:shadow-sm px-6 opacity-50 cursor-not-allowed"
                >
                    {t('course.tabs.reviews')} (0)
                </TabsTrigger>
            </TabsList>

            <TabsContent value="curriculum" className="mt-0 focus-visible:outline-none focus-visible:ring-0">
                {curriculumContent}
            </TabsContent>

            <TabsContent value="overview" className="mt-0 focus-visible:outline-none focus-visible:ring-0">
                {overviewContent || (
                    <Card className="border-none shadow-sm bg-white">
                        <CardContent className="p-6">
                            <h3 className="text-xl font-bold mb-4">{t('course.tabs.overview')}</h3>
                            <div
                                className="prose max-w-none text-gray-600"
                                dangerouslySetInnerHTML={{ __html: course.description || '' }}
                            />
                        </CardContent>
                    </Card>
                )}
            </TabsContent>
        </Tabs>
    );
};
